import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";

/**
 * Component for displaying a key-value card.
 * This component is designed to present data in a key-value pair format, commonly used
 * for displaying concise information in a visually appealing card layout.
 */
@Component({
  selector: "app-key-value-card",
  standalone: true,
  imports: [CommonModule],
  templateUrl: "./key-value-card.component.html",
  styleUrl: "./key-value-card.component.scss",
})
export class KeyValueCardComponent {
  @Input()
  data: any = [];
}
